import api from "../../api/api";
import { toast } from "react-toastify";

// Action Types
export const FETCH_DAILY_RATES_REQUEST = "FETCH_DAILY_RATES_REQUEST";
export const FETCH_DAILY_RATES_SUCCESS = "FETCH_DAILY_RATES_SUCCESS";
export const FETCH_DAILY_RATES_FAILURE = "FETCH_DAILY_RATES_FAILURE";
export const ADD_DAILY_RATE_REQUEST = "ADD_DAILY_RATE_REQUEST";
export const ADD_DAILY_RATE_SUCCESS = "ADD_DAILY_RATE_SUCCESS";
export const ADD_DAILY_RATE_FAILURE = "ADD_DAILY_RATE_FAILURE";
export const UPDATE_DAILY_RATE_REQUEST = "UPDATE_DAILY_RATE_REQUEST";
export const UPDATE_DAILY_RATE_SUCCESS = "UPDATE_DAILY_RATE_SUCCESS";
export const UPDATE_DAILY_RATE_FAILURE = "UPDATE_DAILY_RATE_FAILURE";
export const DELETE_DAILY_RATE_REQUEST = "DELETE_DAILY_RATE_REQUEST";
export const DELETE_DAILY_RATE_SUCCESS = "DELETE_DAILY_RATE_SUCCESS";
export const DELETE_DAILY_RATE_FAILURE = "DELETE_DAILY_RATE_FAILURE";
export const CLEAR_DAILY_RATE_ERROR = "CLEAR_DAILY_RATE_ERROR";

// Utility function to handle errors
const handleError = (error) => {
  if (error.response) {
    return error.response.data?.message || "An error occurred.";
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

// Action Creators

// Fetch all daily rates
export const fetchDailyRates = () => async (dispatch) => {
  dispatch({ type: FETCH_DAILY_RATES_REQUEST });

  try {
    const response = await api.get("/api/DailyRate/all");
    console.log("Fetched Daily Rates:", response.data);
    dispatch({ type: FETCH_DAILY_RATES_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: FETCH_DAILY_RATES_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
};

// Add a new daily rate
export const addDailyRate = (dailyRateData) => async (dispatch) => {
  dispatch({ type: ADD_DAILY_RATE_REQUEST });

  try {
    const response = await api.post("/api/DailyRate/create", dailyRateData);
    dispatch({ type: ADD_DAILY_RATE_SUCCESS, payload: response.data });
    toast.success("Daily rate created successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: ADD_DAILY_RATE_FAILURE, payload: errorMessage });
    toast.error("Daily rate could not be created. Please try again");
  }
};

// Update a daily rate
export const updateDailyRate = (id, dailyRateData) => async (dispatch) => {
  dispatch({ type: UPDATE_DAILY_RATE_REQUEST });

  try {
    const response = await api.put(`/api/DailyRate/${id}`, dailyRateData);
    dispatch({ type: UPDATE_DAILY_RATE_SUCCESS, payload: response.data });
    toast.success("Daily rate updated successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: UPDATE_DAILY_RATE_FAILURE, payload: errorMessage });
    toast.error("Daily rate update failed. Please try again");
  }
};

// Delete a daily rate
export const deleteDailyRate = (id) => async (dispatch) => {
  dispatch({ type: DELETE_DAILY_RATE_REQUEST });

  try {
    await api.delete(`/api/DailyRate/${id}`);
    dispatch({ type: DELETE_DAILY_RATE_SUCCESS, payload: id });
    toast.success("Daily rate deleted successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: DELETE_DAILY_RATE_FAILURE, payload: errorMessage });
    toast.error("Daily rate deletion failed. Please try again");
  }
};

// Clear errors
export const clearDailyRateError = () => ({
  type: CLEAR_DAILY_RATE_ERROR,
});
